/* eslint-disable max-statements */
export const xmlToJson = (str: string | Document): any => {
  let xml = null;
  if (typeof str === 'string') {
    xml = new window.DOMParser().parseFromString(str as string, 'text/xml');
  } else {
    xml = str;
  }

  // Create the return object
  let obj = {};

  if (xml.nodeType === 1) {
    // element
    // do attributes
    if (xml.attributes.length > 0) {
      obj['@attributes'] = {};
      for (let idx = 0; idx < xml.attributes.length; idx++) {
        const attribute = xml.attributes.item(idx);
        obj['@attributes'][attribute.nodeName] = attribute.nodeValue;
      }
    }
  } else if (xml.nodeType === 3) {
    // text
    obj = xml.nodeValue;
  }

  // do children
  if (xml.hasChildNodes()) {
    for (let idx = 0; idx < xml.childNodes.length; idx++) {
      const item = xml.childNodes.item(idx);
      const nodeName = item.nodeName;
      if (typeof obj[nodeName] === 'undefined') {
        obj[nodeName] = xmlToJson(item);
      } else {
        if (typeof obj[nodeName].push === 'undefined') {
          const old = obj[nodeName];
          obj[nodeName] = [];
          obj[nodeName].push(old);
        }
        obj[nodeName].push(xmlToJson(item));
      }
    }
  }

  return obj;
};
